/**
 * UserListSkeleton component
 * Loading skeleton for the user list table
 */
import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'

export interface UserListSkeletonProps {
  /** Number of skeleton rows to display */
  count?: number
  /** Additional CSS classes */
  className?: string
}

/**
 * Skeleton loading state for user list table rows
 */
export function UserListSkeleton({
  count = 5,
  className,
}: UserListSkeletonProps) {
  return (
    <div className={cn('space-y-2', className)}>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          data-testid="user-list-skeleton-row"
          className="flex items-center gap-4 p-4 border rounded-md"
        >
          {/* Avatar skeleton */}
          <Skeleton className="h-10 w-10 rounded-full" />

          {/* Name & Email skeleton */}
          <div className="flex-1 space-y-2">
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-3 w-48" />
          </div>

          {/* Role badge skeleton */}
          <Skeleton className="h-6 w-16 rounded-md" />

          {/* Status skeleton */}
          <Skeleton className="h-4 w-12" />

          {/* Action button skeleton */}
          <Skeleton className="h-8 w-8 rounded-md" />
        </div>
      ))}
    </div>
  )
}
